import { t } from "@lingui/macro";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  KeyboardShortcut,
} from "@reactive-resume/ui";
import { useNavigate } from "react-router";

import { useLogout } from "../services/auth";
import { useAuthStore } from "../stores/auth";
import { useUser } from "../services/user";
import { Role } from "@reactive-resume/utils";

type Props = {
  children: React.ReactNode;
};

export const UserOptions = ({ children }: Props) => {
  const navigate = useNavigate();
  const { logout } = useLogout();
  const { user } = useUser();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>

      <DropdownMenuContent side="top" align="start" className="w-48">
        {/* {
          user?.role === Role.ExtenalUser && (
            <>
            <DropdownMenuItem
              onClick={() => {
                void navigate("/client/user-space/settings");
                //if (user?.role === Role.PromoUser) void navigate("/ambassador/dashboard/settings");
              }}
            >
              {t`Settings`}
              <KeyboardShortcut>⇧S</KeyboardShortcut> 
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            </>
          )
        } */}

        <DropdownMenuItem
          onClick={() => {
            if (user?.role === Role.PromoUser) {
              logout();
              void navigate("/ambassador/auth/login");
            } else if (user?.role === Role.Administrator || user?.role === Role.InternalUser) {
              logout();
              void navigate("/admin/auth/login");
            } else {
              logout();
              void navigate("/client/auth/login");
            }
          }}
        >
          {t`Logout`}
          {/* eslint-disable-next-line lingui/no-unlocalized-strings */}
          <KeyboardShortcut>⇧Q</KeyboardShortcut>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
